(function ($) {
    var $el = $('[data-terms]');
    var $toggle = $('[data-terms="toggle"]');
    if($el.length > 0) {
        $el.on('click', function() {
            btnTrigger($(this), $toggle);
        });
    }
}(jQuery));

function btnTrigger($el, $toggle) {
    if($el.attr('data-target') && $el.data('target') !== '') {
        $($el.data('target')).overlay();
    }
    if($el.data('terms') === 'agree') {
        $toggle.toggleClass('-no-access');
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports-access/reports-access.js